export const MIN_CREDIT_QUANTITY = 1;
export const MAX_CREDIT_QUANTITY = 50;
